import { BaseConnector } from '@/connectors/base.connector';
import { WebAppConfig } from './web-app-config.model';

export class ConfigsConnector extends BaseConnector {
  constructor() {
    super('configs');
  }

  async getWebAppConfig(): Promise<WebAppConfig[]> {
    return (await this.get<WebAppConfig[]>(`/WebAppConfig`)).result;
  }
}
